import { render, staticRenderFns } from "./PaymentTermsSettingWizard.vue?vue&type=template&id=53829f58&"
import script from "./PaymentTermsSettingWizard.vue?vue&type=script&lang=js&"
export * from "./PaymentTermsSettingWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports